import React from 'react';
import './ErrorTextBlocked.scss';
import './ErrorTextBlocked-media.scss';
import {content} from "../../services/content";

const ErrorTextBlocked = ({ counter }: { counter: string }) => {
  return (
    <div className="error">
      <p
        className={`error__text error__text_server`}
        dangerouslySetInnerHTML={{ __html: `${content.errorTextBlocked.message} ${counter}` }}
      ></p>
    </div>
  );
};

export default ErrorTextBlocked;
